// 背景音乐偏好与播放（老板 2026-09-15：设置面板第一项做「菜单音乐」）。
// 偏好存独立 localStorage 键（不进存档 schema，避免版本迁移）。
// 音频文件：public/assets/audio/bgm.mp3（老板提供的 sunnyday.mp3，2026-09-15 就位）。
const KEY = 'dogtrip.ui';

let audio: HTMLAudioElement | null = null;

export function getMusicEnabled(): boolean {
  try {
    return localStorage.getItem(KEY) !== 'music-off';
  } catch {
    return true; // localStorage 不可用时常开偏好，不影响主流程
  }
}

export function setMusicEnabled(on: boolean): void {
  try {
    localStorage.setItem(KEY, on ? 'music-on' : 'music-off');
  } catch {
    // 偏好写不进就只当本次会话生效
  }
  applyMusic(on);
}

function ensureAudio(): HTMLAudioElement {
  if (!audio) {
    audio = new Audio('/assets/audio/bgm.mp3');
    audio.loop = true;
  }
  return audio;
}

// 预载音乐：仅触发缓冲，不播放。播放必须在用户手势（点击「进入」）内调用，
// 否则浏览器自动播放策略会拦截。BootScreen 挂载时调用。
export function prepareAudio(): void {
  try {
    const el = ensureAudio();
    if (el.preload !== 'auto') el.preload = 'auto';
    el.load();
  } catch {
    // 环境不支持（如测试环境）：静默失败
  }
}

function applyMusic(on: boolean): void {
  const el = ensureAudio();
  if (!on) {
    el.pause();
    return;
  }
  el.volume = 0.4;
  if (el.error) el.load(); // 上次加载失败（如文件缺失）后重试
  try {
    const p = el.play() as unknown;
    if (p && typeof (p as Promise<void>).catch === 'function') {
      (p as Promise<void>).catch(() => {
        // 文件缺失 / 自动播放策略拦截：静默失败，开关状态不受影响
      });
    }
  } catch {
    // 环境不支持播放（如测试环境）：静默失败
  }
}

// ─────────────────────────────────────────────────────────────────────
// 自动播放策略恢复（2026-09-18 修 bug：刷新后音乐不响）。
// 浏览器只在**真实用户手势**（点击/触摸/按键）内允许带声音频播放。
// BootScreen 的「进度满自动进入」是 rAF 回调，**不是**手势 → 其中 play() 被拦截（错误被上面 .catch 吞掉）。
// 解法：App 挂载时注册一次性全局监听，用户首次点击/触摸/按键即按偏好启动音乐，触发后注销。
// 视觉仍自动进入（老板 2026-09-16 要求），无需把「进入」改回按钮。
// ─────────────────────────────────────────────────────────────────────
let gestureListenersBound = false;

export function bindFirstGestureToPlay(): void {
  if (gestureListenersBound) return;
  gestureListenersBound = true;

  const events = ['pointerdown', 'keydown', 'touchstart'] as const;
  const handler = () => {
    // 首个真手势：按偏好启动；无论开/关/失败都注销，避免残留监听
    if (getMusicEnabled()) applyMusic(true);
    for (const e of events) window.removeEventListener(e, handler);
    gestureListenersBound = false;
  };

  for (const e of events) {
    window.addEventListener(e, handler, { once: true });
  }
}
